import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class ValidationMessageService {

	private VALIDATION_MESSAGES = {
		required: () => 'Este campo es obligatorio',
		minlength: (e) => `Debe tener mínimo ${e.requiredLength} caracteres`,
		sinMinuscula: () => 'Debe tener una minúscula',
		sinMayuscula: () => 'Debe tener una mayúscula',
		sinCaracterEspecial: () => 'Debe tener un carácter especial',
		errorEmail: () => 'El correo no parece tener un formato adecuado',
		errorCelular: () => 'El celular debe ser numérico y válido'
	};

	build(control: AbstractControl, controlName?: string): string | null {
		if (!control) return null;

		// detectar nombre del control si no viene
		if (!controlName) {
			const parent = control.parent;
			if (parent) {
				controlName = Object.keys(parent.controls)
					.find(key => parent.get(key) === control);
			}
		}

		const controlErrors = control.errors || {};
		const groupErrors = controlName
			? control.parent?.errors?.[controlName] || {}
			: {};

		const allErrors: ValidationErrors = {
			...controlErrors,
			...groupErrors
		};

		if (!Object.keys(allErrors).length) return null;

		return Object.keys(allErrors)
			.map(errorKey => {
				const errorValue = allErrors[errorKey];

				if (errorValue?.message) return errorValue.message;

				const fn = this.VALIDATION_MESSAGES[errorKey];
				return fn ? fn(errorValue) : 'Campo inválido';
			})
			.join('<br>');
	}
}